import pages from "./zh-CN/pages";
import tip from "@/locales/zh-CN/tip";
export default {
  "batch.add.tips": "成功{success}条，失败{error}条",
  ...pages,
  ...tip,
};
